<style lang="scss" scoped>
.slide-14 {
  background-image: url("../../../assets/module5/slide14/bg-08.jpg");
  background-size: cover;
  background-position: center;
  padding-left: 40px;
  padding-top: 70px;
  height: calc(100% - 80px);
}
.quiz {
  overflow: hidden;
  position: absolute;
  right: 90px;
  height: 870px;
  width: 1155px;
  top: 76px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  & > div {
    padding: 30px;
    text-align: center;
  }
}
h3 {
  color: #706f6f;
  font-size: 32px;
  span {
    color: #3b7fc2;
  }
}
p {
  color: #706f6f;
  font-size: 26px;
}
.tl {
  grid-area: 1 / 1 / 2 / 2;
  .options > div {
    height: 150px;
    background-size: 89%;
    background-position: bottom;
    background-repeat: no-repeat;
    &:first-of-type {
      background-image: url(../../../assets/module5/slide14/1x/q1_a.png);
    }
    &:nth-of-type(2) {
      background-image: url(../../../assets/module5/slide14/1x/q1_b.png);
    }
    &:nth-of-type(3) {
      background-image: url(../../../assets/module5/slide14/1x/q1_c.png);
    }
  }
}
.tr {
  grid-area: 1 / 2 / 2 / 3;
  .options > div {
    height: 150px;
    background-size: 100%;
    background-position: bottom;
    background-repeat: no-repeat;
    &:first-of-type {
      background-size: 115%;
      background-image: url(../../../assets/module5/slide14/1x/q2_a.png);
    }
    &:nth-of-type(2) {
      background-size: 130%;
      background-image: url(../../../assets/module5/slide14/1x/q2_b.png);
    }
    &:nth-of-type(3) {
      background-size: 94%;
      background-image: url(../../../assets/module5/slide14/1x/q2_c.png);
    }
  }
}
.bl {
  grid-area: 2 / 1 / 3 / 2;
  .options > div {
    height: 240px;
    background-size: 84%;
    background-position: bottom;
    background-repeat: no-repeat;
    &:first-of-type {
      background-image: url(../../../assets/module5/slide14/1x/q3_a.png);
    }
    &:nth-of-type(2) {
      background-image: url(../../../assets/module5/slide14/1x/q3_b.png);
    }
  }
}
.br {
  grid-area: 2 / 2 / 3 / 3;
  .options > div {
    height: 150px;
    height: 230px;
    background-size: 85%;
    background-position: bottom center;
    background-repeat: no-repeat;
    p {
      color: #3b7fc2;
      font-size: 22px;
      width: 55%;
      margin: 0px auto;
    }
    &:first-of-type {
      background-image: url(../../../assets/module5/slide14/1x/q4_a.png);
    }
    &:nth-of-type(2) {
      background-image: url(../../../assets/module5/slide14/1x/q4_b.png);
    }
    &:nth-of-type(3) {
      background-image: url(../../../assets/module5/slide14/1x/q4_c.png);
    }
  }
}
.options {
  height: auto;
  margin-top: 50px;
  & > div {
    flex: 1;
    position: relative;
    transition: all 0.2s ease-out;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
    span {
      pointer-events: none;
      color: #706f6f;
      font-family: "Kookycat-FASTcaps";
      position: absolute;
      left: 0;
      top: 0;
      font-size: 30px;
    }
  }
}
.selected {
  position: relative;
  z-index: 1;
  &:before {
    z-index: -1;
    transform: translateZ(0);
    border-radius: 100%;
    content: "";
    display: block;
    position: absolute;
    width: 150px;
    height: 150px;
    border: 6px solid #4dbd33;
    animation: bi 0.3s cubic-bezier(0.55, 0, 0.1, 1) forwards;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:not(.correct):before {
    border-color: #ff0033;
  }
}
@keyframes bi {
  from {
    transform: scale(2) translate(-25%, -25%);
    opacity: 0;
    filter: blur(1px);
  }
  to {
    transform: scale(1) translate(-50%, -50%);
    opacity: 1;
  }
}
h1 {
  font-size: 101px;
  color: #09509c;
  transform: rotate(-5deg);
  text-align: center;
}
.left {
  width: 600px;
  text-align: center;
  img {
    width: 240px;
    margin-top: 40px;
    margin-right: -80px;
  }
}
.mid {
  display: inline-block;
  transform: translateX(50px);
  margin-top: 104px;
}
h4 {
  font-size: 34px;
}
h2 {
  transform: none;
  font-size: 96px;
  color: #c5d43b;
}
video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  z-index: 99999999;
  box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
  width: 100%;
  border-radius: 0;
}
</style>

<template>
  <div class="slide-14">
    <transition name="fadeUp" appear>
      <video
        v-if="showVid"
        ref="video"
        autoplay
        src="@/assets/highfive.mp4"
      ></video>
    </transition>

    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 13"
        src="@/assets/module5/slide14/quiz_bg-08.png"
        class="chars delay-3"
      />
    </transition>

    <img src="@/assets/module5/slide14/timmy-08.png" class="chars" />
    <div class="left">
      <transition name="scale" appear>
        <div v-show="slideIndex == 13">
          <h1>Now let’s play our FInal game</h1>
        </div>
      </transition>

      <transition name="scale" appear>
        <div v-show="slideIndex == 13" class="delay-1">
          <div class="mid">
            <h4>Can you see if you can get</h4>
            <h2>all three</h2>
            <h4>stroke symptoms correct?</h4>
          </div>
        </div>
      </transition>

      <transition name="scale" appear>
        <img
          v-show="slideIndex == 13"
          class="delay-2"
          src="@/assets/module5/slide14/2x/click_on_btn@2x.png"
        />
      </transition>
    </div>

    <div class="quiz">
      <transition name="scale" appear>
        <div class="tl delay-4" v-show="slideIndex == 13">
          <h3>
            ACTIVITY 1 RECAP:
            <span>FACE</span>
          </h3>
          <p>Which face shows signs of stroke?</p>
          <div class="flex options">
            <div @click.prevent.stop="selected($event, 'q1answer')">
              <span>A</span>
            </div>
            <div @click="selected($event, 'q1answer')">
              <span>B</span>
            </div>
            <div
              @click="selected($event, 'q1answer', true)"
              :class="{ selected: q1answer, correct: q1answer }"
            >
              <span>C</span>
            </div>
          </div>
        </div>
      </transition>

      <transition name="scale" appear>
        <div class="tr delay-5" v-show="slideIndex == 13">
          <h3>
            ACTIVITY 2 RECAP:
            <span>ARMS</span>
          </h3>
          <p>Which arms show signs of stroke?</p>
          <div class="flex options">
            <div @click="selected($event, 'q2answer')">
              <span>A</span>
            </div>
            <div
              @click="selected($event, 'q2answer', true)"
              :class="{ selected: q2answer, correct: q2answer }"
            >
              <span>B</span>
            </div>
            <div @click="selected($event, 'q2answer')">
              <span>C</span>
            </div>
          </div>
        </div>
      </transition>

      <transition name="scale" appear>
        <div class="bl delay-6" v-show="slideIndex == 13">
          <h3>
            ACTIVITY 3 RECAP:
            <span>SPEECH</span>
          </h3>
          <p>Which lips show signs of stroke?</p>
          <div class="flex options">
            <div @click="selected($event, 'q3answer')">
              <span>A</span>
            </div>
            <div
              @click="selected($event, 'q3answer', true)"
              :class="{ selected: q3answer, correct: q3answer }"
            >
              <span>B</span>
            </div>
          </div>
        </div>
      </transition>

      <transition name="scale" appear>
        <div class="br delay-7" v-show="slideIndex == 13">
          <h3>
            ACTIVITY 4 RECAP:
            <span>TIME</span>
          </h3>
          <p>What must you do if you see a stroke?</p>
          <div class="flex options">
            <div @click="selected($event, 'q4answer')">
              <span>A</span>
              <p>LIE DOWN</p>
            </div>
            <div @click="selected($event, 'q4answer')">
              <span>B</span>
              <p>TAKE A BATH</p>
            </div>
            <div
              @click="selected($event, 'q4answer', true)"
              :class="{ selected: q4answer, correct: q4answer }"
            >
              <span>C</span>
              <p>CALL 000</p>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"],
  data: function() {
    return {
      showVid: false,
      q1answer: false,
      q2answer: false,
      q3answer: false,
      q4answer: false
    };
  },
  methods: {
    selected(e, key, isCorrect = false) {
      if (isCorrect) {
        this[key] = true;
        this.play();
      } else {
        e.target.classList.add("animate__animated", "animate__headShake");
        setTimeout(
          () =>
            e.target.classList.remove(
              "animate__animated",
              "animate__headShake"
            ),
          1000
        );
      }
    },
    play() {
      if (this.q1answer && this.q2answer && this.q3answer && this.q4answer) {
        this.showVid = true;
        this.$nextTick(() => {
          if (this.$refs.video) {
            this.$refs.video.addEventListener(
              "ended",
              () => {
                this.showVid = false;
              },
              false
            );
          }
        });
      }
    }
  }
};
</script>
